import SearchField from 'components/SearchField/SearchField';
import {
	IScheduleViewContext,
	ScheduleViewContext,
} from '../../../scheduleViewContext/scheduleViewState/scheduleViewContext';
import React, { useContext } from 'react';

const Search: React.FC = () => {
	const { changeSearchString, searchString } = useContext<IScheduleViewContext>(ScheduleViewContext);

	return <SearchField onChangeSelectSearchString={changeSearchString} searchString={searchString} delay={800} />;
};

export default Search;
